export default __webpack_public_path__ + "static/media/skillset-data.e8b34771.svg";